<template>
  <el-aside
    v-show="calcShowAside"
    :style="{
      'webkit-overflow-scrolling': 'touch',
      overflow: 'auto',
      background: '#354b68',
      height: '100vh',
      width: '70px',
      position: 'fixed',
      left: 0,
      top: 0,
      bottom: 0,
      color: 'white',
      zIndex: 10,
    }"
  >
    <SideMenu />
  </el-aside>
  <el-main
    :style="{
      height: '100vh',
      overflow: 'inherit',
      background: 'white',
      marginLeft: isWechatBrowser ? 0 : '70px',
      padding: 0,
    }"
    :class="{ 'main-container': !isWechatBrowser }"
    id="main-container"
  >
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </el-main>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import SideMenu from './SideMenu.vue';
import { useRoute } from 'vue-router';
import { isWechatBrowser } from '@/lib/utils';

const route = useRoute();
const keepAlive = ref(route.meta.keep_alive);
const key = ref(route.fullPath);
const calcShowAside = computed(
  () =>
    !['/payment', '/login', '/resetPassword', '/webview', '/officialToMini'].includes(location?.pathname) &&
    !isWechatBrowser
);
</script>
<style lang="less">
.el-aside::-webkit-scrollbar,
.main-container::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}
</style>
